export default __webpack_public_path__ + "static/media/pheasant.bf35e6a2.webp";